var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 5.55798H14.2969V14.2969H0.703125V5.55798Z",
    fill: "#2F47BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 6.96423H7.96875V7.90174H7.03125V6.96423Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 6.96423H11.9062V7.90174H10.9688V6.96423Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09375 11.9531H4.03125V12.8906H3.09375V11.9531Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 11.9531H7.96875V12.8906H7.03125V11.9531Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09375 9.45868H4.03125V10.3962H3.09375V9.45868Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 9.45868H7.96875V10.3962H7.03125V9.45868Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 9.45868H11.9062V10.3962H10.9688V9.45868Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 6.02672V2.17641H12.8906V0.703125H11.9531V2.17641H7.96875V0.703125H7.03125V2.17641H3.98438V3.11391H13.8281V5.08922H1.17188V3.11391H3.04688V0.703125H2.10938V2.17641H0.234375V14.7656H14.7656V6.96422H13.8281V13.8281H1.17188V6.02672H14.7656Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8b9c29e53e919db0c7f982a31a75078e.svg";
export { ForwardRef as ReactComponent };